export default __webpack_public_path__ + "static/media/auditory.bbe5ec40.svg";